import FirstRoundLetterComp from "components/FirstRoundLetter/FirstRoundLetter";
import { CommonCardContainer } from "components/DashboardCards/cardStyles";
import queryString from "query-string";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from "use-debounce";

import DeleteJobModal from "../../Jobs/DeleteJobModal";
import EditJobPopupContainer from "../../Jobs/EditJobPopup/EditJobPopupContainer";
import defaultLocationIcon from "../../../assets/img/icons/default-location-filled.svg";
import LocationIcon from "../../../assets/img/icons/location_icon.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import {
  PrimaryButton,
  PrimaryWhiteBgButton,
} from "../../../styledComponents/buttons";
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonRoundImageContainer,
  CommonText,
  Container,
  ContentHeader,
  InputLabel,
  InputWithLabelSection,
  PageTitle,
} from "../../../styledComponents/common";
import { AssigneesManageImgTextGrid } from "../../../styledComponents/createProject";
import DeleteClientModal from "../DeleteClientModal";
import StaticTaskLocationModal from "./StaticTaskLocationModal";
import deleteIcon from "../../../assets/img/icons/delete_new.svg";
import { LocationItem, LocationContent } from "../../../styledComponents/clients";
import { MapButton } from "../EditClient/EditClient";
import { HorizontalLineDivider } from "styledComponents/Activity";
import RoundTab from "components/RoundTabButtons/RoundTab";
import JobList from "../../Jobs/JobList";
import TopPagination from "../../../components/Pagination/TopPagination/TopPagination";
import BottomPagination from "../../../components/Pagination/BottomPagination/BottomPagination";
import { ClientNameRow } from "../../../styledComponents/clients";

const ClientDetails = ({
  selectedOrganization,
  location,
  clientLocationList,
  clientDetails,
  clientLocationCreateUpdateSuccess,
  createdClientLocationInfo,
  isLoading,
  clientDeleteLoading,
  jobDeleteLoading,
  totaljobsCount,
  isLoadingJobs,
  pageSizeJob,
  jobList,
  history,
  getClientDetails,
  getClientLocation,
  deleteClient,
  deleteJob,
  getJobList,
}) => {
  const [clientID, setclientId] = useState(null);
  const [clientLocations, setClientLocations] = useState([]);
  const [modalDeleteClient, setModalDeleteClient] = useState(false);
  const [staticLocationModalOpen, setStaticLocationModalOpen] = useState(false);
  const [selectedStaticLocation, setSelectedStaticLocation] = useState(null);
  const [locationIndex, setLocationIndex] = useState(null);
  const [defaultLocation, setDefaultLocation] = useState(-1);
  const [jobTabs, setJobTabs] = useState('all');
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [expandedTaskId, setExpandedTaskId] = useState(null);
  const [isEditJobPopupOpen, setIsEditJobPopupOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteJobWorkOrderId, setDeleteJobWorkOrderId] = useState(null);
  const [jobIdDelete, setJobIdDelete] = useState(null);
  const [updatedJobId, setUpdatedJobId] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          client_id: queryParsed.id,
        };
        setclientId(payload.client_id);
        getClientDetails(payload);
      }
    }
  }, [selectedOrganization, location, getClientDetails]);

  useEffect(() => {
    if (clientLocationList && clientLocationList.length > 0) {
      setClientLocations(clientLocationList);
      const defaultIndex = clientLocationList.findIndex(loc => loc.default === true);
      setDefaultLocation(defaultIndex);
    } else if (clientLocationList && clientLocationList.length === 0) {
      setClientLocations([]);
      setDefaultLocation(-1);
    }
  }, [clientLocationList]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          client_id: queryParsed.id,
        };
        getClientLocation(payload);
      }
    }
  }, [selectedOrganization, location, getClientLocation]);



  useEffect(() => {
    if (
      clientLocationCreateUpdateSuccess &&
      selectedOrganization &&
      selectedOrganization.id &&
      clientID
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        client_id: clientID,
      };
      getClientLocation(payload);
    }
  }, [clientLocationCreateUpdateSuccess, selectedOrganization, clientID, getClientLocation]);

  useEffect(() => {
    if (
      createdClientLocationInfo &&
      createdClientLocationInfo.id &&
      selectedOrganization &&
      selectedOrganization.id &&
      clientID
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        client_id: clientID,
      };
      getClientLocation(payload);
    }
  }, [createdClientLocationInfo, selectedOrganization, clientID, getClientLocation]);

  const toggle = () => setModalDeleteClient(!modalDeleteClient);

  const handleShowLocation = (location, index) => {
    setSelectedStaticLocation(location);
    setLocationIndex(index);

    setTimeout(() => {
      setStaticLocationModalOpen(true);
    }, 300);
  };

  const handlePageChange = page => {
    setCurrentPageNumber(page);
  };

  const toggleDeleteModal = (jobId, workOrderId) => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    if (jobId && workOrderId) {
      setJobIdDelete(jobId);
      setDeleteJobWorkOrderId(workOrderId);
    }
  };

  const handleClientDelete = useDebouncedCallback(clientId => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        client_id: clientId,
      };

      deleteClient(payload);

      setTimeout(() => {
        setModalDeleteClient(false);
        history.push({
          pathname: "/user/customers",
          state: { from: "details" },
        });
      }, 500);
    }
  }, 500);



  const handleJobDelete = useDebouncedCallback(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      jobIdDelete &&
      deleteJobWorkOrderId
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        workOrder_id: deleteJobWorkOrderId,
        job_id: jobIdDelete,
        reloadJobList:
          Math.ceil(totaljobsCount / pageSizeJob) !== currentPageNumber,
      };

      deleteJob(payload);
      toggleDeleteModal();
    }
  }, 500);

  // Reset page to 1 when jobTabs changes
  useEffect(() => {
    setCurrentPageNumber(1);
  }, [jobTabs]);

  useEffect(() => {
    if (selectedOrganization?.id && clientID) {
      const payload = {
        organization_id: selectedOrganization.id,
        client_id: clientID,
        date: moment().format('YYYY-MM-DD'),
        page: currentPageNumber,
        per_page: pageSizeJob,
      };

      if (jobTabs !== 'all') {
        payload.approval_status = jobTabs;
      }

      getJobList(payload);
    }
  }, [selectedOrganization, clientID, jobTabs, currentPageNumber, pageSizeJob, getJobList]);

  const handleJobUpdateChange = value => {
    if (value) {
      setUpdatedJobId(Date.now());
    }
  };

  useEffect(() => {
    if (updatedJobId && selectedOrganization?.id && clientID) {
      const payload = {
        organization_id: selectedOrganization.id,
        client_id: clientID,
        date: moment().format('YYYY-MM-DD'),
        page: currentPageNumber,
        per_page: pageSizeJob,
      };

      if (jobTabs !== 'all') {
        payload.approval_status = jobTabs;
      }

      getJobList(payload);
    }
  }, [updatedJobId, selectedOrganization, clientID, currentPageNumber, pageSizeJob, jobTabs, getJobList]);

  return (
  <div className="content">
    <DeleteJobModal
      isOpen={isDeleteModalOpen}
      toggle={() => toggleDeleteModal()}
      handleDelete={handleJobDelete}
      isLoading={jobDeleteLoading}
    />
    <EditJobPopupContainer
      isOpen={isEditJobPopupOpen}
      toggle={() => setIsEditJobPopupOpen(!isEditJobPopupOpen)}
      selectedJob={selectedJob}
      setSelectedJob={setSelectedJob}
      onUpdateChange={handleJobUpdateChange}
    />

    <StaticTaskLocationModal
      isOpen={staticLocationModalOpen}
      toggle={() => {
        setStaticLocationModalOpen(false);
        setSelectedStaticLocation(null);
      }}
      taskLocation={selectedStaticLocation}
      locationIndex={locationIndex}
    />

    {clientDetails && clientDetails.id && (
      <DeleteClientModal
        id={clientDetails.id}
        isOpen={modalDeleteClient}
        toggle={toggle}
        handleDelete={handleClientDelete}
        isLoading={clientDeleteLoading}
      />
    )}

    <ContentHeader>
      <BackButtonComponent
        onClick={() => history.push("/user/customers")}
        subTitle={t("back_to_all_customers")}
      />
    </ContentHeader>

    <Container
      padding="20px"
      borderRadius="16px 16px 0 0"
      marginTop="32px"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "16px",
      }}
    >
      {isLoading && !isEditJobPopupOpen ? (
        <ComponentCircleLoader />
      ) : (
        <>
          {clientDetails && clientDetails?.name && (
            <>
            <CommonFlex disableResponsive justifyContent="space-between" alignItems="center" wrap>
              <PageTitle>{t("customer_details")}</PageTitle>
              <CommonGrid alignItem="flex-end" columns="auto auto"  gap="8px">
                <PrimaryWhiteBgButton onClick={() => history.push(`/user/edit-customer?id=${clientDetails.id}`) }>
                  {t("edit_customer")}
                </PrimaryWhiteBgButton>
                <CommonRoundImageContainer bgColor="#EDF8FF" size="40px">
                <CommonImage
                    src={deleteIcon}
                    cursor="pointer"
                    onClick={toggle}
                  />
                </CommonRoundImageContainer>
              </CommonGrid>
              </CommonFlex>
              <CommonGrid  disableResponsive responsiveBreakpoint="780px" responsiveColumns="1fr" alignItem="flex-start"  columns="1fr 1fr">
                <CommonFlex  alignItems="flex-start" direction="column" gap="0px">
                <ClientNameRow>
                    <AssigneesManageImgTextGrid>
                      <FirstRoundLetterComp
                        text={clientDetails.name}
                        backColor={0}
                        color={clientDetails.color}
                      />
                      <CommonText title name>{clientDetails.name}</CommonText>
                    </AssigneesManageImgTextGrid>
                  </ClientNameRow>
                {/* Email and Phone Number */}
                <CommonGrid columns="1fr 1fr" columnGap="40px">
                  <InputWithLabelSection>
                    <CommonText title name>
                      {clientDetails?.phone_number}
                    </CommonText>
                    <InputLabel>{t('contact_number')}</InputLabel>
                  </InputWithLabelSection>
                  <InputWithLabelSection>
                    <CommonText title name>
                      {clientDetails?.email}
                    </CommonText>
                    <InputLabel>{t('email_address')}</InputLabel>
                  </InputWithLabelSection>
                </CommonGrid>
                </CommonFlex>
                <CommonCardContainer style={{marginTop: "25px" ,width:"100%"}} bgColor="#EDF8FE">
                  <CommonText fontWeight="600" margin="0 0 15px 0">
                    Locations
                  </CommonText>
                  <CommonFlex disableResponsive direction="column" gap="12px">
                    {clientLocations?.length > 0 ? (
                      clientLocations.map((location, index) => (
                        <LocationItem key={index}>
                          <LocationContent>
                            <CommonImage src={LocationIcon} size="20px" />
                            <div>
                              <CommonText fontWeight="600" fontSize="14px">
                                {location.name}
                              </CommonText>
                              <CommonText fontSize="12px" color="#666">
                                {location.address}
                              </CommonText>
                            </div>
                          </LocationContent>
                          {index === defaultLocation && (
                            <CommonImage src={defaultLocationIcon} style={{cursor:"pointer"}} />
                          )}
                          <MapButton
                          onClick={() => handleShowLocation(location, index)}
                        >
                          Map
                        </MapButton>
                        </LocationItem>
                      ))
                    ) : (
                      <LocationItem>
                        <LocationContent>
                          <CommonText fontSize="14px" color="#999">
                            No locations added
                          </CommonText>
                        </LocationContent>
                      </LocationItem>
                    )}
                  </CommonFlex>
                </CommonCardContainer>
              </CommonGrid>
              <HorizontalLineDivider margin="5px 0" />
              <CommonFlex disableResponsive justifyContent="space-between" alignItems="center" wrap>
              <PageTitle>{t("job")}</PageTitle>
              <CommonFlex gap="4px" alignItems="center">
                    <RoundTab
                      text="All"
                      selected={jobTabs === 'all'}
                      onClick={() => setJobTabs('all')}
                      showIcon={false}
                      filled={true}
                    />
                    <RoundTab
                      text="Pending"
                      selected={jobTabs === 'pending'}
                      onClick={() => setJobTabs('pending')}
                      showIcon={false}
                      filled={true}
                    />
                    <RoundTab
                      text="Approved"
                      selected={jobTabs === 'approved'}
                      onClick={() => setJobTabs('approved')}
                      showIcon={false}
                      filled={true}
                    />
                    <RoundTab
                      text="Rejected"
                      selected={jobTabs === 'rejected'}
                      onClick={() => setJobTabs('rejected')}
                      showIcon={false}
                      filled={true}
                    />
                  </CommonFlex>
              </CommonFlex>

              {totaljobsCount && totaljobsCount > 0 && pageSizeJob ? (
                <TopPagination
                  itemName={t("jobs")}
                  totalCount={totaljobsCount}
                  currentPage={currentPageNumber}
                  onPageChange={page => handlePageChange(page)}
                  pageSize={pageSizeJob}
                />
              ) : null}

              <JobList
                selectedOrganization={selectedOrganization}
                expandedTaskId={expandedTaskId}
                setExpandedTaskId={setExpandedTaskId}
                toggleDeleteModal={toggleDeleteModal}
                history={history}
                jobList={jobList}
                isLoading={isLoadingJobs}
                taskStatus={{}}
                setIsEditJobPopupOpen={setIsEditJobPopupOpen}
                setSelectedJob={setSelectedJob}
              />

              {totaljobsCount && totaljobsCount > 0 && pageSizeJob ? (
                <BottomPagination
                  totalCount={totaljobsCount}
                  currentPage={currentPageNumber}
                  onPageChange={page => handlePageChange(page)}
                  pageSize={pageSizeJob}
                />
              ) : null}

            </>
          )}
        </>
      )}
    </Container>
  </div>
  );
};

export default ClientDetails;